import OemLogoImg from '@/shared/assets/images/OemLogo.png'

export const SidebarLogo = () => {
    return (
        <div className='w-[180px] h-[46px]'>
            <img src={OemLogoImg} alt="" className='object-contain w-full h-full' />
        </div>
    )
}
